import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {communicationChannelAction} from "redux/actions";


export default function UpdateCommChannel({editableDetails, onUpdate}) {

    const [channelsName, setChannelsName] = useState('');
    const [updateid, setUpdateid] = useState(0);


    const {customers, userRole} = useSelector(state => ({
        customers: state.customers,
        userRole: state.userRole?.filter(role => role.module === "Customers")
    }));

    const dispatch = useDispatch();
    useEffect(() => {
        setChannelsName(editableDetails.channel_name);
        setUpdateid(editableDetails.id);
    }, [editableDetails]);

    const updateData = () =>{
        dispatch(communicationChannelAction.update({ id: updateid, name: channelsName}));
        setChannelsName('');
        onUpdate();
    } 

   
    return (
        <div>
            <h2>Update Communication Channel</h2>
            <form action="">
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="channels_name">Channels Name:</label>
                    <input type="text" className="form-control" id="channels_name" placeholder="Enter Channels Name" name="channels_name" onChange={e => setChannelsName(e.target.value)} value={channelsName}/>
                </div>
                <div className="form-group" style={{marginBottom:"15px",textAlign:"right"}}>
                    <button type="button" className="btn btn-primary" onClick={updateData}>Update</button>
                </div>
            </form>
        </div>
    );
}
